"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Page;
exports.useDarkMode = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CssBaseline = _interopRequireDefault(require("@mui/material/CssBaseline"));
var _aos = _interopRequireDefault(require("aos"));
var _notistack = require("notistack");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useDarkMode = () => {
  const [themeMode, setTheme] = (0, _react.useState)('dark');
  const [mountedComponent, setMountedComponent] = (0, _react.useState)(false);
  const setMode = mode => {
    try {
      window.localStorage.setItem('themeMode', mode);
    } catch {
      /* do nothing */
    }
    setTheme(mode);
  };
  const themeToggler = () => {
    themeMode === 'light' ? setMode('dark') : setMode('light');
  };
  (0, _react.useEffect)(() => {
    try {
      const localTheme = window.localStorage.getItem('themeMode');
      localTheme ? setTheme(localTheme) : setMode('dark');
    } catch {
      setMode('dark');
    }
    setMountedComponent(true);
  }, []);
  return [themeMode, themeToggler, mountedComponent];
};
exports.useDarkMode = useDarkMode;
function Page(_ref) {
  let {
    children,
    appFactory
  } = _ref;
  _react.default.useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
    _aos.default.init({
      delay: 0,
      duration: 250,
      offset: 0,
      easing: 'ease-in-out',
      useClassNames: true,
      animatedClassName: 'animated'
    });
  }, []);
  const [themeMode, themeToggler, mountedComponent] = useDarkMode();
  (0, _react.useEffect)(() => {
    _aos.default.refresh();
  }, [mountedComponent, themeMode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_notistack.SnackbarProvider, {
      maxSnack: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CssBaseline.default, {}), children]
    })
  });
}
Page.propTypes = {
  children: _propTypes.default.node.isRequired
};